import { render } from "./PortalHomeDashboard.vue?vue&type=template&id=222f3eaf&scoped=true"
import script from "./PortalHomeDashboard.vue?vue&type=script&lang=js"
export * from "./PortalHomeDashboard.vue?vue&type=script&lang=js"

import "./PortalHomeDashboard.vue?vue&type=style&index=0&id=222f3eaf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222f3eaf"]])

export default __exports__